import { render } from "./UnpublishTestimonialDialog.vue?vue&type=template&id=6b71ffb8"
import script from "./UnpublishTestimonialDialog.vue?vue&type=script&lang=js"
export * from "./UnpublishTestimonialDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__